
const digest = '8cb466b427629b6e7f4393f42783b170d210d8b24bec1b471195bb426a920e03';
const classes = {"attachmentButton":"_attachmentButton_1rz3h_1","icon":"_icon_1rz3h_8","remove":"_remove_1rz3h_12","title":"_title_1rz3h_16","additionalText":"_additionalText_1rz3h_22","actionButton":"_actionButton_1rz3h_28","disabledTitle":"_disabledTitle_1rz3h_47","iconRight":"_iconRight_1rz3h_55","button":"_button_1rz3h_59","green":"_green_1rz3h_72","blue":"_blue_1rz3h_76","red":"_red_1rz3h_80","white":"_white_1rz3h_84","disabled":"_disabled_1rz3h_47","badge":"_badge_1rz3h_93","skCircle":"_sk-circle_1rz3h_102","skChild":"_sk-child_1rz3h_102","linkButton":"_linkButton_1rz3h_106","smallButton":"_smallButton_1rz3h_128","fitContent":"_fitContent_1rz3h_170"};
const css = `._attachmentButton_1rz3h_1 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
._attachmentButton_1rz3h_1 ._icon_1rz3h_8 {
  width: 20px;
  height: 20px;
}
._attachmentButton_1rz3h_1 ._remove_1rz3h_12 {
  width: 20px;
  height: 20px;
}
._attachmentButton_1rz3h_1 ._title_1rz3h_16 {
  font-size: 14px;
  color: #1665d8;
  font-weight: 500;
  text-decoration: underline;
}
._attachmentButton_1rz3h_1 ._additionalText_1rz3h_22 {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}

._actionButton_1rz3h_28 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  width: max-content;
}
._actionButton_1rz3h_28 ._icon_1rz3h_8 {
  width: 15px;
  height: 15px;
}
._actionButton_1rz3h_28 ._title_1rz3h_16 {
  font-size: 14px;
  color: #1665d8;
  font-weight: 500;
  text-decoration: underline;
  text-wrap: nowrap;
}
._actionButton_1rz3h_28 ._disabledTitle_1rz3h_47 {
  font-size: 14px;
  color: #737373;
  font-weight: 500;
  text-decoration: underline;
  cursor: not-allowed;
}

._iconRight_1rz3h_55 {
  flex-direction: row-reverse;
}

._button_1rz3h_59 {
  font-size: 14px;
  font-weight: 500;
  padding: 13px 24px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  border-radius: 21.5px;
  cursor: pointer;
  font-family: Rubik, "sans-serif";
  justify-content: center;
  display: flex;
  align-items: center;
  gap: 10px;
}
._button_1rz3h_59._green_1rz3h_72 {
  background-color: #619612;
  color: #ffffff;
}
._button_1rz3h_59._blue_1rz3h_76 {
  background-color: #1665d8;
  color: #ffffff;
}
._button_1rz3h_59._red_1rz3h_80 {
  background-color: #d81616;
  color: #ffffff;
}
._button_1rz3h_59._white_1rz3h_84 {
  color: #ffffff;
}
._button_1rz3h_59._disabled_1rz3h_47 {
  background-color: #737373;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.8;
}
._button_1rz3h_59 ._badge_1rz3h_93 {
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 1px 6px;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f12848;
}
._button_1rz3h_59 ._sk-circle_1rz3h_102 ._sk-child_1rz3h_102:before {
  background-color: #ffffff;
}

._linkButton_1rz3h_106 {
  font-weight: 500;
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
  display: inline-block;
  text-align: center;
}
._linkButton_1rz3h_106._blue_1rz3h_76 {
  color: #1665d8;
}
._linkButton_1rz3h_106._green_1rz3h_72 {
  color: #619612;
}
._linkButton_1rz3h_106._red_1rz3h_80 {
  color: #d81616;
}
._linkButton_1rz3h_106._disabled_1rz3h_47 {
  color: #737373;
  cursor: not-allowed;
}

._smallButton_1rz3h_128 {
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  cursor: pointer;
  font-family: Rubik, "sans-serif";
  justify-content: center;
  display: flex;
}
._smallButton_1rz3h_128._green_1rz3h_72 {
  background-color: #619612;
  color: #ffffff;
}
._smallButton_1rz3h_128._blue_1rz3h_76 {
  background-color: #1665d8;
  color: #ffffff;
}
._smallButton_1rz3h_128._red_1rz3h_80 {
  background-color: #d81616;
  color: #ffffff;
}
._smallButton_1rz3h_128._disabled_1rz3h_47 {
  background-color: #737373;
  color: #ffffff;
  cursor: not-allowed;
  opacity: 0.8;
}
._smallButton_1rz3h_128 ._badge_1rz3h_93 {
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  padding: 1px 4px;
  border-radius: 4px;
  margin-left: 8px;
  background-color: #f12848;
  display: flex;
  align-items: center;
  justify-content: center;
}

._fitContent_1rz3h_170 {
  width: fit-content;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  